module.exports = "https://r.nearpod.com/assets/media/image/npp_preview-ca5471da1267ad2b1490ee1b18cec11b.svg";